import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, unwrap } from '../api/client';
import type { Notification } from '../api/types';
import { Badge, DataTable, Empty, ErrorAlert, fmtDate, PageHeader } from '../components/ui';

export function NotificationsPage() {
  const qc = useQueryClient();
  const q = useQuery({
    queryKey: ['notifications'],
    queryFn: () =>
      unwrap(api.get<{ items: Notification[]; unread: number }>('/portal/notifications')),
  });
  const read = useMutation({
    mutationFn: (id: string) => unwrap(api.post(`/portal/notifications/${id}/read`)),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
  return (
    <>
      <PageHeader
        title="Notifications"
        subtitle={`${q.data?.unread ?? 0} unread: token expiry, renewal and account health, Meta API errors, failed messages, posts and automations, payment and subscription events, webhooks that stopped, nested flows that did not start, flows that failed, and AI replies that fell back`}
      />
      <ErrorAlert error={q.error} />
      <DataTable>
        <table className="table">
          <thead>
            <tr>
              <th>Severity</th>
              <th>Kind</th>
              <th>Message</th>
              <th>When</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {(q.data?.items ?? []).map((n) => (
              <tr key={n.id} style={{ fontWeight: n.readAt ? 400 : 600 }}>
                <td>
                  <Badge value={n.severity} />
                </td>
                <td>{n.kind.replace(/_/g, ' ')}</td>
                <td>{n.title}</td>
                <td>{fmtDate(n.createdAt)}</td>
                <td>
                  {n.readAt ? null : (
                    <button type="button" className="btn btn-sm" onClick={() => read.mutate(n.id)}>
                      Mark read
                    </button>
                  )}
                </td>
              </tr>
            ))}
            {q.data?.items.length === 0 ? (
              <tr>
                <td colSpan={5}>
                  <Empty>
                    No notifications. You will see token expiry, delivery failures and Meta API
                    errors here.
                  </Empty>
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </DataTable>
    </>
  );
}
